import { Pipe, PipeTransform } from '@angular/core';
import { CurrencyPipe, DatePipe, DecimalPipe } from '@angular/common';

@Pipe({
	name: 'dynamicPipe'
})
export class DynamicPipe implements PipeTransform {
	constructor(
		private currencyPipe: CurrencyPipe,
		private datePipe: DatePipe,
		private decimalPipe: DecimalPipe
	) {}

	transform(value: any, pipeName: string): any {
		if (value === null || value === undefined || value === '') {
			return '-';
		}

		switch (pipeName) {
			case 'currency':
				return this.currencyPipe.transform(value, 'USD', 'symbol', '1.2-2'); // Convert value to number
			case 'date':
				return this.datePipe.transform(value, 'shortDate');
			case 'datetime':
				return this.datePipe.transform(value, 'MM/dd/yyyy h:mm a');
			case 'decimal':
				return this.decimalPipe.transform(value, '1.3-3');
			case 'title':
				return value.toString().replace(/\w\S*/g, (txt: string) => {
					return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
				});
			default:
				return value;
		}
	}
}
